import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Strips HTML tags from a string and returns plain text.
 * Used to validate rich text editor content by actual text length.
 */
export function stripHtmlTags(html: string): string {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').trim();
}

/**
 * Validators for rich text (HTML) content - checks plain text length, not HTML length.
 */
/**
 * Required validator for rich text (HTML) content.
 * Standard Validators.required passes for empty editors because they return '<p><br></p>'.
 */
export function htmlRequired(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const plainText = stripHtmlTags(control.value);
    if (plainText.length === 0) {
      return { required: true };
    }
    return null;
  };
}

export function htmlMinLength(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const plainText = stripHtmlTags(control.value);
    if (plainText.length > 0 && plainText.length < minLength) {
      return { minlength: { requiredLength: minLength, actualLength: plainText.length } };
    }
    return null;
  };
}

export function htmlMaxLength(maxLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const plainText = stripHtmlTags(control.value);
    if (plainText.length > maxLength) {
      return { maxlength: { requiredLength: maxLength, actualLength: plainText.length } };
    }
    return null;
  };
}

export function imageCountValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!Array.isArray(value)) return null;
    if (value.length < min) {
      return { imageCount: { min, max, actual: value.length, message: `Wymagane minimum ${min} zdjęć` } };
    }
    if (value.length > max) {
      return { imageCount: { min, max, actual: value.length, message: `Maksymalnie ${max} zdjęć` } };
    }
    return null;
  };
}

export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate = control.get('startDate')?.value;
    const endDate = control.get('endDate')?.value;

    if (!startDate || !endDate) return null;

    if (new Date(startDate) >= new Date(endDate)) {
      return { dateRange: { message: 'Data początku musi być przed datą końca' } };
    }

    return null;
  };
}

export function requiredIfValidator(conditionField: string, conditionValue: unknown): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const parent = control.parent;
    if (!parent) return null;

    const conditionControl = parent.get(conditionField);
    if (!conditionControl) return null;

    if (conditionControl.value === conditionValue) {
      if (control.value === null || control.value === undefined || control.value === '') {
        return { requiredIf: { message: 'To pole jest wymagane' } };
      }
    }

    return null;
  };
}
